module.exports = __webpack_public_path__ + "static/04-894b61e5f40e078fd8ef118dc85a232b.jpg";